import * as styles from './styles.css';

export interface IDisclaimerTrigger {
  onClick: () => void;
  disclaimerActive?: boolean;
}

const DisclaimerTrigger = ({ onClick, disclaimerActive }: IDisclaimerTrigger) => {
  const className = disclaimerActive ? `${styles.bold} ${styles.link} ` : styles.link;
  return (
    <a onClick={onClick} className={className}>
      Legal Disclaimer
    </a>
  );
};

export default DisclaimerTrigger;
